export const languageElements = {
    items: {
        "button-CANCEL": {
            hu: "Mégsem",
            de: "Abbrechen",
            en: "Cancel",
        },

        "button-DELETE": {
            hu: "Törlés",
            de: "Löschen",
            en: "Delete",
        },

        "title": {
            hu: "Adatsor törlése",
            de: "Datensatz löschen",
            en: "Delete record"
        },

        "body": {
            hu: "Valóban töröljem az adatsor(oka)t?",
            de: "Datensatz / Datensätze löschen?",
            en: "Delete record(s)?"
        },
    }
}
